export default "__VITE_ASSET__CALtR4yH__"